import React from 'react';
import PropTypes from 'prop-types';

const Text = ({
  children,
  variant = 'body',
  className = '',
  tag,
}) => {
  const variants = {
    pageTitle: 'app-text-page-title',
    sectionTitle: 'app-text-section-title',
    cardTitle: 'app-text-card-title',
    subheading: 'app-text-subheading',

    body: 'app-text-body',
    bodyStrong: 'app-text-body-strong',
    muted: 'app-text-muted',
    small: 'app-text-small',

    label: 'app-text-label',
    helper: 'app-text-helper',

    error: 'app-text-error',
    success: 'app-text-success',
    warning: 'app-text-warning',
    info: 'app-text-info',

    statValue: 'app-text-stat-value',
    statLabel: 'app-text-stat-label',

    tableHeader: 'app-text-table-header',
    tableCell: 'app-text-table-cell',
  };

  const tagMap = {
    pageTitle: 'h1',
    sectionTitle: 'h2',
    cardTitle: 'h3',
    subheading: 'p',

    body: 'p',
    bodyStrong: 'p',
    muted: 'p',
    small: 'small',

    label: 'label',
    helper: 'small',

    error: 'small',
    success: 'small',
    warning: 'small',
    info: 'small',

    statValue: 'h2',
    statLabel: 'p',

    tableHeader: 'th',
    tableCell: 'td',
  };

  const Tag = tag || tagMap[variant] || 'p';

  return (
   <Tag className={`${variants[variant]} ${className}`}>
      {children}
    </Tag>
  );
};

Text.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  className: PropTypes.string,
  tag: PropTypes.elementType,
};

export default Text;
